(ns common.schema.entities.ribbon
  (:require
   [common.schema.schema-utils :as su]))

;; TODO: add more fields and field permissions
(def schema
  (concat
   (su/text-simple-field :ribbon/name
                         "Name"
                         {})

   (su/text-multiline-field :ribbon/description
                            "Description"
                            {})

   (su/multi-ref-field :ribbon/default-tabs
                       "Default tabs"
                       [:entity.type/tab]
                       {})))
;; Plus
;; :common/owner ?
